import { useBattlePassDetails } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
import { useBattlePassDaresDifficultyLevels, useBattlePassDaresPlatforms, useBattlePassDaresStatus, useBattlePassDropMnemonicId, useBattlePassTier, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import { ProjectStatus } from 'root/src/shared/@types/project';
import { useMemo } from 'react';
import { DareStatus, DropMnemonicIdFilter } from 'root/src/client/v2/battlePass/constants';
import { isPlatform } from 'root/src/shared/platforms/guards/platform.guards';
export const useBattlePassFilteredDrops = () => {
    const { drops } = useBattlePassDetails();
    const { dropMnemonicIds } = useBattlePassDropMnemonicId();
    const { dareStatus } = useBattlePassDaresStatus();
    const { tier } = useBattlePassTier();
    const { platforms } = useBattlePassDaresPlatforms();
    const { levels } = useBattlePassDaresDifficultyLevels();
    const filteredDrops = filterDrops(drops, dropMnemonicIds);
    return useMemo(() => {
        return filteredDrops
            .map(drop => filterDaresByStatus(drop, dareStatus))
            .map(drop => filterDaresByTiers(drop, tier))
            .map(drop => filterDaresByPlatforms(drop, platforms))
            .map(drop => filterDaresByDifficultyLevels(drop, levels));
    }, [drops, dropMnemonicIds, dareStatus, tier, platforms, levels]);
};
const filterDrops = (drops, mnemonicIds) => {
    if (mnemonicIds.includes(DropMnemonicIdFilter.All)) {
        return drops;
    }
    return drops.filter(drop => mnemonicIds.includes(drop.mnemonicId));
};
const filterDaresByTiers = (drop, tier) => {
    const filteredDares = drop.dares.filter(dare => { var _a; return ((_a = dare.battlePass) === null || _a === void 0 ? void 0 : _a.tier) === tier; });
    return Object.assign(Object.assign({}, drop), { dares: filteredDares });
};
const filterDaresByStatus = (drop, daresStatus) => {
    if (daresStatus === DareStatus.All) {
        return drop;
    }
    const projectStatuses = getProjectStatusesByDaresStatus(daresStatus);
    const filteredDares = drop.dares.filter((dare) => {
        if (!dare.status) {
            return false;
        }
        return projectStatuses.includes(dare.status);
    });
    return Object.assign(Object.assign({}, drop), { dares: filteredDares });
};
const filterDaresByPlatforms = (drop, platforms) => {
    const dares = drop.dares.filter((dare) => {
        if (isPlatform(dare.platform)) {
            return platforms.includes(dare.platform);
        }
        return true;
    });
    return Object.assign(Object.assign({}, drop), { dares });
};
const filterDaresByDifficultyLevels = (drop, levels) => {
    const dares = drop.dares.filter((dare) => {
        return levels.includes(dare.level);
    });
    return Object.assign(Object.assign({}, drop), { dares });
};
const getProjectStatusesByDaresStatus = (daresStatus) => {
    if (daresStatus === DareStatus.Active) {
        return [ProjectStatus.ProjectAccepted, ProjectStatus.DeliveryPending, ProjectStatus.Pending];
    }
    if (daresStatus === DareStatus.Completed) {
        return [ProjectStatus.Approved, ProjectStatus.ProjectDelivered];
    }
    return [];
};
